export const highlightCustomStyles = {
  color: ({ palette }) => palette.text.tableHighlight,
};
